import { DeviceVersionState, RootState, DeviceVersion } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import DeviceTypeService from '@/services/devicetype.service';
import { getDeviceImage } from '@/classes/images';

type DeviceGetter = GetterTree<DeviceVersionState, RootState>;

export const initialState = (): DeviceVersionState => {
  return {
    initialState,
    versions: [],
    total: 0,
  };
};

export const getters: DeviceGetter = {
  versions: (state) => state,
  versionsToList: (state) => (search: string) => {
      return {items: state.versions.filter((item) => {
        return  search.length === 0 || item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
      }).map(DeviceMethods.versionsToList)};
    },
};

export const mutations: MutationTree<DeviceVersionState> = {
  addVersions(state, newVersions) {
    state.total = newVersions.length;
    state.versions = newVersions;
  },
};

export const actions: ActionTree<DeviceVersionState, RootState> = {
  async addVersionsAsync(context) {
    const catalogue = await DeviceTypeService.getCatalogue();
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < catalogue.length; i++) {
      const deviceVersion = catalogue[i];
      deviceVersion.image = getDeviceImage(deviceVersion);
    }
    context.commit('addVersions', catalogue);
    return catalogue;
  },
};

export class DeviceMethods {
  public static versionsToList(version: any): any {
    return {
      id: version.id,
      title: version.name,
      image: version.image,
      manufacturer: version.manufacturer_name,
      slug: version.slug,
      bearer: version.bearer,
    };
  }
}

export const versions: Module<DeviceVersionState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
